import { ApplicationEvent } from './../Event/ApplicationEvent';
import { InternalFeature } from '../InternalFeatures/InternalFeature';
import { InternalFeatureService } from '../InternalFeatures/InternalFeatureService';
import { ApplicationStage } from '../Application/ApplicationStage';
import { SyncEvent } from '../Event/SyncEvent';
import { ContactPublicKeySet, FillItemContent, TrustedContact, } from '@standardnotes/models';
import { ContentType } from '@standardnotes/domain-core';
const SelfContactName = 'Me';
export class SelfContactManager {
    constructor(sync, items, session, singletons) {
        this.session = session;
        this.singletons = singletons;
        this.isReloadingSelfContact = false;
        this.eventDisposers = [];
        this.eventDisposers.push(sync.addEventObserver((event) => {
            if (event === SyncEvent.LocalDataIncrementalLoad) {
                this.loadSelfContactFromDatabase();
            }
            if (event === SyncEvent.SyncCompletedWithAllItemsUploaded) {
                void this.reloadSelfContactAndCreateIfNecessary();
            }
        }));
        this.eventDisposers.push(items.addObserver(ContentType.TYPES.TrustedContact, () => {
            const updatedReference = this.singletons.findSingleton(ContentType.TYPES.TrustedContact, TrustedContact.singletonPredicate);
            if (updatedReference) {
                this.selfContact = updatedReference;
            }
        }));
    }
    async handleEvent(event) {
        if (event.type === ApplicationEvent.ApplicationStageChanged) {
            const stage = event.payload.stage;
            if (stage === ApplicationStage.LoadedDatabase_12) {
                this.loadSelfContactFromDatabase();
            }
        }
    }
    loadSelfContactFromDatabase() {
        if (this.selfContact) {
            return;
        }
        this.selfContact = this.singletons.findSingleton(ContentType.TYPES.TrustedContact, TrustedContact.singletonPredicate);
    }
    async reloadSelfContactAndCreateIfNecessary() {
        if (!InternalFeatureService.get().isFeatureEnabled(InternalFeature.Vaults)) {
            return;
        }
        if (this.selfContact) {
            return;
        }
        if (this.isReloadingSelfContact) {
            return;
        }
        if (!this.session.isSignedIn()) {
            return;
        }
        if (this.session.isUserMissingKeyPair()) {
            return;
        }
        this.isReloadingSelfContact = true;
        const content = {
            name: SelfContactName,
            isMe: true,
            contactUuid: this.session.getSureUser().uuid,
            publicKeySet: ContactPublicKeySet.FromJson({
                encryption: this.session.getPublicKey(),
                signing: this.session.getSigningPublicKey(),
                timestamp: new Date(),
            }),
        };
        this.selfContact = await this.singletons.findOrCreateSingleton(TrustedContact.singletonPredicate, ContentType.TYPES.TrustedContact, FillItemContent(content));
        this.isReloadingSelfContact = false;
    }
    deinit() {
        this.eventDisposers.forEach((disposer) => disposer());
        this.session = undefined;
        this.singletons = undefined;
    }
}
